/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import cn from 'classnames';
import { string, shape, bool } from 'prop-types';
import { Helmet } from 'react-helmet';
import { Route } from 'react-router-dom';
import { withRouter, Redirect } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import { ROUTES } from '~constants/routes';
import LocalStorage from '~services/LocalStorageService';
import Navbar from '~components/Navbar';
import SideBar from '~components/SideBar';
import { setTokenHeader } from '~config/api';
import AdminUserActions from '~redux/AdminUser/actions';
import LoadingWrapper from '~components/Spinner/LoadingWrapper';
import useRefreshFirebaseToken from '~hooks/useRefreshFirebaseToken';

import styles from './styles.module.scss';

const AuthenticatedRoute = ({ title, description, path, noNavbar, noSideBar, publicRoute, ...props }) => {
  useEffect(() => window.scrollTo({ top: 0, behavior: 'smooth' }), []);
  const tokenManager = LocalStorage.getTokenManager();
  const dispatch = useDispatch();
  const logged = tokenManager?.accessToken;

  useEffect(() => {
    if (logged) {
      setTokenHeader(tokenManager.accessToken);
      dispatch(AdminUserActions.getCurrentUser());
    }
  }, [dispatch]);

  const { kdsAccess, adminUserLoading } = useSelector((state) => state.adminUser);
  useRefreshFirebaseToken(logged, tokenManager);

  return publicRoute && logged ? (
    <Redirect
      to={{
        pathname: ROUTES.HOME.path
      }}
    />
  ) : logged || publicRoute ? (
    <LoadingWrapper loading={adminUserLoading}>
      {(kdsAccess || publicRoute) && (
        <>
          <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
          </Helmet>
          <div className={cn(styles.containerSite, 'item-1')}>
            {!noNavbar && <Navbar />}
            <div
              className={cn('column center full-width full-height', {
                [styles.mainContent]: !noNavbar
              })}>
              <div className="row full-width full-height overflow-y-hidden">
                {!noSideBar && <SideBar />}
                <Route path={path} {...props} />
              </div>
            </div>
          </div>
        </>
      )}
    </LoadingWrapper>
  ) : (
    <Redirect
      to={{
        pathname: ROUTES.LOGIN.path
      }}
    />
  );
};

AuthenticatedRoute.defaultProps = {
  noNavbar: true,
  noSideBar: false
};

AuthenticatedRoute.propTypes = {
  path: string.isRequired,
  publicRoute: bool.isRequired,
  description: string,
  location: shape({
    pathname: string
  }),
  noNavbar: bool,
  noSideBar: bool,
  title: string
};

export default withRouter(AuthenticatedRoute);
